import { Button } from '@mui/material'
import { MarkInvoiceAsPendingCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";

interface IProps {
  recordIds: string[]
  userId: string
}

const InvoiceMarkInvoiceAsPendingButton = ({recordIds, userId}: IProps) => {
  
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPendingCommand) => 
    apiService.InvoicesApi.markInvoiceAsPending({markInvoiceAsPendingCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPending = () => { 
    recordIds.forEach(async recordId => {
      const command: MarkInvoiceAsPendingCommand = {
        id: recordId,
        userId: userId,
      }
      mutate(command)
    })
  }

  return (
    <Button 
      disabled={isLoading} 
      size='small' 
      onClick={markInvoiceAsPending} 
    >
      {translate(`resources.invoices.pending`)}
    </Button>
  )
}

export default InvoiceMarkInvoiceAsPendingButton